<template>
  <div class="animated fadeIn">
    <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div class="row">
              <div class="col-sm-6">
                  <h4 class="card-title mb-0">
                    Delivery Label Management<small class="text-muted"> upload order to download label</small>
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">

              </div><!--col-->
          </div><!--row-->
          <hr />
          <form>
            <div class="form-group row">
              <label for="costFile" class="col-sm-2 col-form-label">Orders File</label>
              <div class="col-sm-8">
                <label class="file">
                  <input type="file" name="file" id="file" @change="fileChange($event.target.name, $event.target.files)">
                  <span class="file-custom"></span>
                </label>

                <small id="costFile" class="form-text text-danger">
                  Click <a href="/download/delivery/orderLabelTemplate.xlsx" class="font-weight-bold" target="_blank"> HERE </a> to get tempalte
                </small>
              </div>
            </div>
            <div slot="footer">
              <b-button type="submit" size="sm" @click.stop.prevent="handleUpload" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            </div>
           </form>
        </b-card>
      </div>
    </div>
    <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>

<script>
import loadingPanel from '@/components/LoadingPanel'
import FileSaver from 'file-saver'
import moment from 'moment'

export default {
  name: 'UploadDownloadLabel',
  components: {
    loadingPanel
  },
  data () {
    return {
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      file: '',
      formData: new FormData()
    }
  },
  methods: {
    fileChange (fileName, fileList) {
      if (!fileList.length) {
        return
      }
      this.formData.append(fileName, fileList[0], fileList[0].name)
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    handleUpload () {
      var config = {
        // onUploadProgress: function (progressEvent) {
          // var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        // }
        onUploadProgress: function () {
          // var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        },
        responseType: 'blob'
        
      }
      this.showLoadingPanel = true
      this.axios.post('delivery/order/upload-download-label', this.formData, config)
        .then(response => {
          this.showLoadingPanel = false
          FileSaver.saveAs(response, moment().format('YYYY-MM-DD') + '-waybill.pdf')
          this.showAlert('success', "downlaod waybill success")
        })
        .catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
    }
  }
}
</script>
